import axios from '@/plugins/axios'

const BASE = 'prospeccao'

export async function enviarProspeccaoPf(body) {
  const { data } = await axios.post(`${BASE}/pf/enviar`, body)
  return data
}

export async function statusProspeccaoPf(id) {
  const { data } = await axios.get(`${BASE}/pf/status/${encodeURIComponent(id)}`)
  return data
}

export async function contagemProspeccaoPf(body) {
  const { data } = await axios.post(`${BASE}/pf/contagem`, body)
  return data
}

export async function listarProspeccoesPf(body = {}) {
  const { data } = await axios.post(`${BASE}/pf/listar`, body, {
    silentNotify: true,
  })
  return data
}

export async function retornoProspeccaoPf(id) {
  const { data } = await axios.post(`${BASE}/pf/retorno/${encodeURIComponent(id)}`)
  return data
}

export async function aprovarProspeccaoPf(body) {
  const { data } = await axios.post(`${BASE}/pf/aprovar`, body)
  return data
}

export async function recusarProspeccaoPf(body) {
  const { data } = await axios.post(`${BASE}/pf/recusar`, body)
  return data
}

export async function enviarProspeccaoPj(body) {
  const { data } = await axios.post(`${BASE}/pj/enviar`, body)
  return data
}

export async function statusProspeccaoPj(id) {
  const { data } = await axios.get(`${BASE}/pj/status/${encodeURIComponent(id)}`)
  return data
}

export async function contagemProspeccaoPj(body) {
  const { data } = await axios.post(`${BASE}/pj/contagem`, body)
  return data
}

export async function listarProspeccoesPj(body = {}) {
  const { data } = await axios.post(`${BASE}/pj/listar`, body, {
    silentNotify: true,
  })
  return data
}

export async function retornoProspeccaoPj(id) {
  const { data } = await axios.post(`${BASE}/pj/retorno/${encodeURIComponent(id)}`)
  return data
}

export async function aprovarProspeccaoPj(body) {
  const { data } = await axios.post(`${BASE}/pj/aprovar`, body)
  return data
}

export async function recusarProspeccaoPj(body) {
  const { data } = await axios.post(`${BASE}/pj/recusar`, body)
  return data
}

export async function downloadProspeccao(id) {
  const { data } = await axios.get(`${BASE}/download/${encodeURIComponent(id)}`)
  return data
}

export async function getCidadesProspeccao() {
  const { data } = await axios.get(`${BASE}/cidades`, {
    silentNotify: true,
  })
  return data
}

export async function getCidadesPorEstadoProspeccao(estado) {
  const { data } = await axios.post(
    `${BASE}/cidades-por-estado`,
    { estado },
    { silentNotify: true },
  )
  return data
}

export async function getBairrosPorCidadeProspeccao(cidade, uf) {
  const { data } = await axios.post(
    `${BASE}/bairros-por-cidade`,
    { cidade, uf },
    { silentNotify: true },
  )
  return data
}

export async function getBairrosPorCodigoIbgeProspeccao({
  ibgeCode,
  cityName,
  uf,
}) {
  const { data } = await axios.post(
    `${BASE}/bairros-por-codigo-ibge`,
    { ibgeCode, cityName, uf },
    { silentNotify: true },
  )
  return data
}

export async function getCbosProspeccao() {
  const { data } = await axios.get(`${BASE}/cbos`, {
    silentNotify: true,
  })
  return data
}

export async function getCnaesProspeccao() {
  const { data } = await axios.get(`${BASE}/cnaes`, {
    silentNotify: true,
  })
  return data
}

export async function getPortesProspeccao() {
  const { data } = await axios.get(`${BASE}/portes`, {
    silentNotify: true,
  })
  return data
}

export async function getNaturezasJuridicasProspeccao() {
  const { data } = await axios.get(`${BASE}/naturezas-juridicas`, {
    silentNotify: true,
  })
  return data
}

export async function getSituacoesEmpresaProspeccao() {
  const { data } = await axios.get(`${BASE}/situacoes-empresa`, {
    silentNotify: true,
  })
  return data
}
